import {
    initialEditState,
    initialState,
    EditState,
    State,
} from 'mk2/apps/bazaar/containers/EditProduct/EditProduct.reducers';
import { AppState } from 'mk2/reducers';

export const getEditProductState = (state: AppState): State => state.containers.bazaar.editProduct || initialState;
export const getEditProductProductState = (state: AppState, slug: string): EditState =>
    getEditProductState(state).edits[slug] || initialEditState;
